<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Control Logs'
                    : 'Deleted Control Logs'
                "
              ></h3>
              <!-- <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/control_logs/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="3">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col sm="3">
                  <v-autocomplete
                    ref="therapySession"
                    solo
                    rounded
                    v-model="filter.therapy_session_id"
                    :items="therapySessionItems"
                    label="Therapy Session"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-medical-bag"
                    clearable
                  ></v-autocomplete>
                </v-col> -->
                <v-col sm="3">
                  <v-autocomplete
                    ref="action"
                    solo
                    rounded
                    v-model="filter.action"
                    :items="actionItems"
                    label="Action"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-play"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="control_logs.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
                :loading="isExcelloading"
                :disabled="isExcelloading"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" :style="`height: ${tableHeight}px`">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="tableHeight"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start">Action</th>
                      <th class="text-start">Patient Name</th>
                      <th class="text-start">Therapist</th>
                      <th class="text-start">Device ID</th>
                      <th class="text-start">Speed</th>
                      <th class="text-start">Unweighting %</th>
                      <th class="text-start">Description</th>
                      <th class="text-start">Created At</th>
                    </tr>
                  </thead>
                  <tbody v-if="control_logs.length != 0">
                    <tr
                      v-for="(log, i) in control_logs"
                      :key="`log_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                      }"
                    >
                      <td>{{ serialNoStarting + i }}</td>
                      <td>
                        <v-tooltip bottom v-if="log.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Session Log is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="log.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Session Log is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-chip
                          :color="getActionColor(log.action)"
                          text-color="white"
                          small
                        >
                          <v-icon left small>{{
                            getActionIcon(log.action)
                          }}</v-icon>
                          {{ getActionDisplayName(log.action) }}
                        </v-chip>
                      </td>
                      <td>
                        {{
                          log.therapy_session && log.therapy_session.patient
                            ? log.therapy_session.patient.first_name
                            : " "
                        }}
                      </td>
                      <td>
                        {{
                          log.therapist
                            ? log.therapist.first_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          log.therapy_session && log.therapy_session.device
                            ? log.therapy_session.device.model_name
                            : ""
                        }}
                      </td>

                      <td>{{ log.speed ? log.speed + " km/h" : "N/A" }}</td>
                      <td>
                        {{
                          log.unweighting_percentage
                            ? log.unweighting_percentage + "%"
                            : "N/A"
                        }}
                      </td>
                      <td class="text-truncate" style="max-width: 200px">
                        {{ log.description || "N/A" }}
                      </td>
                      <td>{{ formatDate(log.created_at) }}</td>
                     
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Delete Confirmation Dialog -->
      <v-dialog v-model="delete_log" max-width="500px">
        <v-card>
          <v-card-title class="headline">Delete Control Log</v-card-title>
          <v-card-text>
            Are you sure you want to delete this control log? This action cannot
            be undone.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="delete_log = false">
              Cancel
            </v-btn>
            <v-btn color="red darken-1" text @click="confirmDelete()">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Restore Confirmation Dialog -->
      <!-- <v-dialog v-model="restore_log" max-width="500px">
        <v-card>
          <v-card-title class="headline">Restore Control Log</v-card-title>
          <v-card-text>
            Are you sure you want to restore this control log?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="restore_log = false">
              Cancel
            </v-btn>
            <v-btn color="green darken-1" text @click="confirmRestore()">
              Restore
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";

export default {
  name: "ControlLogsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        therapy_session_id: "",
        action: "",
        show_deleted: false,
      },
      page: 1,
      rowsPerPage: 10,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      delete_log: false,
      restore_log: false,
      selectedLogId: null,
      control_logs: [],
      therapySessionItems: [],
      actionItems: [
        {
          id: "speed_increase",
          text: "Speed Increase",
          value: "speed_increase",
        },
        {
          id: "speed_decrease",
          text: "Speed Decrease",
          value: "speed_decrease",
        },
        {
          id: "emergency_stop",
          text: "Emergency Stop",
          value: "emergency_stop",
        },
        { id: "pause_session", text: "Pause Session", value: "pause_session" },
        {
          id: "resume_session",
          text: "Resume Session",
          value: "resume_session",
        },
        {
          id: "unweighting_change",
          text: "Unweighting Change",
          value: "unweighting_change",
        },
        { id: "session_start", text: "Session Start", value: "session_start" },
        { id: "session_end", text: "Session End", value: "session_end" },
        { id: "safety_check", text: "Safety Check", value: "safety_check" },
      ],
      statuses: [
        { id: 0, text: "Select Active Status", value: "" },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      isLoading: false,
      isExcelloading: false,
    };
  },
  computed: {
    tableHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 250;
        case "sm":
          return 300;
        case "md":
          return 400;
        case "lg":
          return 500;
        case "xl":
          return 600;
        default:
          return 400;
      }
    },
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    // Check for therapy_session_id in query params and set filter
    if (this.$route.query.therapy_session_id) {
      this.filter.therapy_session_id = this.$route.query.therapy_session_id;
    }
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get(`masters?context=control_log`);
        const masters = response.data;

        // Therapy Sessions
        if (masters.therapy_sessions) {
          masters.therapy_sessions.forEach((session) => {
            this.therapySessionItems.push({
              id: session.id,
              text: `Session #${session.id} - ${session.patient.first_name} ${session.patient.last_name}`,
              value: session.id,
            });
          });
        }
      } catch (error) {
        console.error("Error fetching masters:", error);
      }
    },
    isDeletePage() {
      return this.$route.query.open_trash ? true : false;
    },
    async getData() {
      this.isLoading = true;
      console.log("route params", this.$route.params.sessionId);

      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active || "";
      if (this.$route.params.sessionId) {
        this.filter.therapy_session_id = this.decryptIt(
          this.$route.params.sessionId
        );
      } else {
        this.filter.therapy_session_id = "";
      }

      let query = new URLSearchParams({
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        show_deleted: this.filter.show_deleted,
        is_active: this.filter.is_active,
        search_keyword: this.filter.search_keyword,
        therapy_session_id: this.filter.therapy_session_id || "",
        action: this.filter.action || "",
      }).toString();

      try {
        const response = await axios.get(`control_logs?${query}`);
        this.control_logs = response.data.data;
        this.count = response.data.count;
        this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        this.serialNoStarting = (this.page - 1) * this.rowsPerPage + 1;
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          //window.location.href = "/auth/login";
        }
      } finally {
        this.isLoading = false;
      }
    },
    Delete_this(id) {
      this.selectedLogId = id;
      this.delete_log = true;
    },
    async confirmDelete() {
      try {
        await axios.post(`control_logs/delete/${this.selectedLogId}`);
        this.delete_log = false;
        this.getData();
      } catch (error) {
        console.error("Error deleting:", error);
        if (error.response && error.response.status === 401) {
          //window.location.href = "/auth/login";
        }
      }
    },
    Restore_this(id) {
      this.selectedLogId = id;
      this.restore_log = true;
    },
    // async confirmRestore() {
    //   try {
    //     await axios.post(`control_logs/restore/${this.selectedLogId}`);
    //     this.restore_log = false;
    //     this.getData();
    //   } catch (error) {
    //     console.error("Error restoring:", error);
    //     if (error.response && error.response.status === 401) {
    //       //window.location.href = "/auth/login";
    //     }
    //   }
    // },
    async generateExcel() {
      this.isExcelloading = true;
      try {
        const queryParams = new URLSearchParams({
          search_keyword: this.filter.search_keyword || "",
          is_active: this.filter.is_active || "",
          therapy_session_id: this.filter.therapy_session_id || "",
          action: this.filter.action || "",
        }).toString();

        const response = await axios.get(`control_logs/excel?${queryParams}`, {
          responseType: "blob",
        });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "control_logs.xlsx";
        link.click();
      } catch (error) {
        console.error("Error generating Excel:", error);
      } finally {
        this.isExcelloading = false;
      }
    },
    getActionDisplayName(action) {
      const actionMap = {
        speed_increase: "Speed Increase",
        speed_decrease: "Speed Decrease",
        emergency_stop: "Emergency Stop",
        pause_session: "Pause Session",
        resume_session: "Resume Session",
        unweighting_change: "Unweighting Change",
        session_start: "Session Start",
        session_end: "Session End",
        safety_check: "Safety Check",
      };
      return actionMap[action] || action;
    },
    getActionIcon(action) {
      const iconMap = {
        speed_increase: "mdi-speedometer",
        speed_decrease: "mdi-speedometer-slow",
        emergency_stop: "mdi-stop-circle",
        pause_session: "mdi-pause-circle",
        resume_session: "mdi-play-circle",
        unweighting_change: "mdi-weight",
        session_start: "mdi-play",
        session_end: "mdi-stop",
        safety_check: "mdi-shield-check",
      };
      return iconMap[action] || "mdi-information";
    },
    getActionColor(action) {
      const colorMap = {
        speed_increase: "success",
        speed_decrease: "warning",
        emergency_stop: "error",
        pause_session: "info",
        resume_session: "success",
        unweighting_change: "primary",
        session_start: "success",
        session_end: "primary",
        safety_check: "warning",
      };
      return colorMap[action] || "secondary";
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleString();
    },
  },
};
</script>

<style scoped>
.table-row-even {
  background-color: #f5f5f5;
}
.table-row-odd {
  background-color: #ffffff;
}
.striped-table {
  border-collapse: separate;
  border-spacing: 0;
}
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
